import React from 'react'
import { Spinner } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const ListStoreComponent: React.FC<any> = ({
  id,
  videos,
  page,
  setPage,
  hasNextPage,
  loading,
  title,
  onResetListVideo
}) => {
  const onLoadMoreVideo = (e: any) => {
    e.preventDefault()
    setPage(page + 1)
  }

  const onSeeLessVideo = (e: any) => {
    e.preventDefault()
    onResetListVideo()
  }

  return (
    <div className="video-group mt-3" id={id}>
      <div className="head-line">
        <h3>{title}</h3>
        {hasNextPage && page === 1
          && (
            <a href="#" onClick={onLoadMoreVideo}>
              <i className="bi bi-chevron-down" /> もっと見る
            </a>
          )}
      </div>
      <div className="video-list">
        {
          videos && videos.map((video: any) => (
            <Link className="video-items store-home-items" key={video.id} to={`/shop/${video.id}`}>
              {video.introduceThumbnailUrl
                ? <img src={video.introduceThumbnailUrl} alt={video.storeName} />
                : null}
            </Link>
          ))
        }
      </div>
      {page > 1
        && (
          <div className="list-video-footer">
            {hasNextPage
              && (
                <a href="#" className="me-3" onClick={onLoadMoreVideo}>
                  <i className="bi bi-chevron-down" /> もっと見る
                </a>
              )}
            <a href="#" onClick={onSeeLessVideo}>
              <i className="bi bi-chevron-up" /> 閉じる
            </a>
          </div>
        )}
      {loading && <Spinner animation="border" />}
    </div>
  )
}

export default ListStoreComponent
